var sa = sa || {};
sa.Cookie = sa.Cookie || {};

sa.Cookie.COOKIE_ALERT = 'cookie_accept';


//COOKIES
sa.Cookie.init = function() {
	if (!localStorage[sa.Cookie.COOKIE_ALERT]) {
		sa.Cookie.alert();
		sa.Cookie.closeEvent();
	}
}

sa.Cookie.alert = function() {
	if (!'content' in document.createElement('template')) return;

	var template = document.getElementById('cookie-alert');

	if (template) {
		clone = template.content.cloneNode(true);
		document.body.appendChild(clone);
	}
}

sa.Cookie.closeEvent = function() {

	var button = document.querySelector('.site-alert button');

	button.addEventListener('click', function(){

		localStorage.setItem(sa.Cookie.COOKIE_ALERT, 1);
		this.closest('.site-alert').classList.add('hide');

	});
	
}


document.addEventListener("DOMContentLoaded", function(event) { 
	sa.Cookie.init();
});